/**
 * Created by cahyo on 09/05/18.
 */


export const validImageFiles = [
  '.jpg',
  '.jpeg',
  '.gif',
  '.png',
  '.svg'
];

export const validFormatFiles = [
  '.jpg',
  '.jpeg',
  '.gif',
  '.png',
  '.svg',
  '.pdf',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.xls',
  '.xlsx',
  '.mp3',
  '.ogg',
  '.amr',
  '.m4a',
  '.wav',
  '.aac',
  '.zip',
  '.rar'
];

/**
 * Proceeds Array of file format to
 * string for compatibility as html accept attributes
 *
 * @param {Array<any>} arr
 * @returns {any}
 */
export const reducer = (arr: Array<any>) => {
  return arr.reduce(function (accu, item, index) {
    return index === 0 ? accu + item : accu + ", " + item
  }, '');
};

export const acceptFormatFiles = reducer(validFormatFiles);

/**
 * Get valid mimetype based on formatfile.
 * For constructoring File
 *
 * @param {string} formatFile
 * @returns {string}
 */
export const getMimeType = (formatFile: string = 'jpg'): string => {
  let validImages = validImageFiles.reduce((accu: any, item: string) =>
    accu || item === `.${formatFile}`, false);

  if (validImages) {
    return 'image/' + formatFile;
  }

  return 'application/' + formatFile;
};
